import React from 'react'
import { BadgeCard } from '@pandiafi/components'
import { Tooltip } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import type { CoreDayReservableArea } from '../../../common/validations/contractDayReservableAreasSchema'
import {
  areaIcons,
  areaTitle,
  areaDisplayId,
  areaPriceFor,
} from './uiSelectors'
import { mapStatus, fmtCurrency } from './dayReservableAreas.helpers'

type Props = {
  area: CoreDayReservableArea
  onOpen?: (area: CoreDayReservableArea) => void
}

export const DayReservableAreaBadgeCard: React.FC<Props> = ({
  area,
  onOpen,
}) => {
  const { t, i18n } = useTranslation('storage')
  const { primary } = areaIcons(area)

  const title = areaTitle(area)
  const displayId = areaDisplayId(area)

  const price = areaPriceFor(area, null)
  const priceLabel =
    typeof price === 'number' ? fmtCurrency(price, i18n.language) : undefined

  const status = mapStatus(area)
  const open = () => onOpen?.(area)

  return (
    <Tooltip
      tooltipClassName="mx-0 w-56 text-left"
      triggerArea={
        <BadgeCard
          variant="access-policy"
          icon={primary}
          identifier={displayId}
          status={status}
          onClick={open}
          HTMLProps={{
            'aria-label': title,
            role: 'button',
            tabIndex: 0,
            onKeyDown: (e) => (e.key === 'Enter' || e.key === ' ') && open(),
          }}
        />
      }
    >
      <div className="p-2">
        <p className="font-bold">{title}</p>
        {area.buildingPartLocationDetails && (
          <p className="text-sm">{area.buildingPartLocationDetails}</p>
        )}
        {priceLabel && (
          <p className="text-sm mt-1">
            {`${t('price.label')}: ${t('price.perMonth', { amount: priceLabel })}`}
          </p>
        )}
      </div>
    </Tooltip>
  )
}
